import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Input } from '@nextui-org/react';
import React from 'react';

type InputSearchUi = {
  onSearchChange: (_: string) => void;
  isClearable?: boolean;
  placeholder?: string;
  className?: string;
};

export const InputSearchUI = (props: InputSearchUi) => (
  <Input
    size='sm'
    startContent={<MagnifyingGlassIcon strokeWidth={1} className='h-5 w-5' />}
    className={props.className || 'w-15'}
    isClearable={props.isClearable}
    placeholder={props.placeholder || 'Search'}
    onChange={e => props.onSearchChange(e.target.value)}
    onClear={() => props.onSearchChange('')}
  />
);
